import { useRouter } from "@core/Api/useRouter";
import useSetArticleDiffView from "@core-ui/hooks/diff/useSetArticleDiffView";
import { getNewCommitOidFromPathname } from "@ext/git/actions/Revisions/logic/utils/getCommitOidFromPathname";
import type { DiffFlattenTreeAnyItem } from "@ext/git/core/GitDiffItemCreator/RevisionDiffPresenter";
import { FileStatus } from "@ext/Watchers/model/FileStatus";
import { useCallback } from "react";

/** An article the revision kept opens in the catalog at that revision, like the revision itself. */
export const useOpenRevisionEntry = (commitOid: string, parentOid?: string) => {
	const router = useRouter();
	const setArticleDiffView = useSetArticleDiffView({ commit: commitOid }, parentOid ? { commit: parentOid } : "HEAD");

	return useCallback(
		(entry: DiffFlattenTreeAnyItem) => {
			const opensInRevisionCatalog =
				entry.type === "item" &&
				entry.overview.status !== FileStatus.delete &&
				getNewCommitOidFromPathname(entry.pathname) === commitOid;
			if (!opensInRevisionCatalog) return setArticleDiffView(entry);
			void router.pushPath(entry.pathname, { diff: "1", scope: undefined, oldScope: undefined });
		},
		[commitOid, router, setArticleDiffView],
	);
};
